import { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { userLogoutOp } from '../../redux/operations/user.operations';
import { motion } from 'framer-motion';
// * React icons
import { RxVideo } from 'react-icons/rx';
import { BsImages } from 'react-icons/bs';
import { IoIosArrowBack } from 'react-icons/io';
import { FaRegCalendarDays } from 'react-icons/fa6';
import { AiOutlineAppstore, AiOutlineLogout } from 'react-icons/ai';
import { useMediaQuery } from 'react-responsive';
import { FaTasks } from 'react-icons/fa';
import { CiDollar } from 'react-icons/ci';
import { MdMenu } from 'react-icons/md';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { LuNewspaper } from 'react-icons/lu';
import { IoNewspaperOutline } from 'react-icons/io5';
import { FaUsers } from 'react-icons/fa';
import { MdSettings } from 'react-icons/md';
import { SiGoogleforms } from 'react-icons/si';
import { MdOutlinePostAdd } from 'react-icons/md';
import { FaFileWaveform } from 'react-icons/fa6';
import SubMenu from './SubMenu';
import { useSelector } from 'react-redux';
const Sidebar = ({ open, setOpen }) => {
  let isTabletMid = useMediaQuery({ query: '(max-width: 2560px)' });
  // const [open, setOpen] = useState(isTabletMid ? false : true);
  const sidebarRef = useRef();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { role } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(userLogoutOp());
    localStorage.removeItem('userAuthToken');
    localStorage.removeItem('locationIp');
    navigate('/seva-login');
  };

  useEffect(() => {
    if (isTabletMid) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [isTabletMid]);

  useEffect(() => {
    isTabletMid && setOpen(false);
  }, [pathname]);

  const Nav_animation = isTabletMid
    ? {
        open: {
          x: 0,
          width: '16rem',
          transition: {
            damping: 40,
          },
        },
        closed: {
          x: -250,
          width: 0,
          transition: {
            damping: 40,
            delay: 0.15,
          },
        },
      }
    : {
        open: {
          width: '16rem',
          transition: {
            damping: 40,
          },
        },
        closed: {
          width: '4rem',
          transition: {
            damping: 40,
          },
        },
      };

  const settingsMenusList = [
    {
      name: 'Portal Update',
      icon: MdSettings,
      menus: [
        {
          name: 'News',
          icon: <LuNewspaper size={23} className="min-w-max" />,
          link: 'news',
        },
        {
          name: 'Users',
          icon: <FaUsers size={23} className="min-w-max" />,
          link: 'all-users',
        },
        {
          name: 'Images',
          icon: <BsImages size={23} className="min-w-max" />,
          link: 'images',
        },
        {
          name: 'Videos',
          icon: <RxVideo size={23} className="min-w-max" />,
          link: 'videos',
        },
        {
          name: 'AMO Calendar',
          icon: <FaRegCalendarDays size={23} className="min-w-max" />,
          link: 'calendar',
        },
      ],
    },
  ];
  const formsMenusList = [
    {
      name: 'Forms',
      icon: SiGoogleforms,
      menus: [
        {
          name: 'General Grievance',
          icon: <LuNewspaper size={23} className="min-w-max" />,
          link: '',
        },
        {
          name: 'TTD Darshan Request',
          icon: <IoNewspaperOutline size={23} className="min-w-max" />,
          link: '',
        },
        {
          name: 'CMRF/PMRF Application',
          icon: <FaFileWaveform size={23} className="min-w-max" />,
          link: '',
        },
      ],
    },
  ];
  // className={`md:hidden fixed inset-0 max-h-screen z-[999] bg-black/50 ${
  //   open ? 'block' : 'hidden'
  // } `}
  return (
    <div>
      <div
        onClick={() => setOpen(false)}
        className={`fixed inset-0 max-h-screen z-[999] bg-black/50 ${
          open ? 'block' : 'hidden'
        } `}
      ></div>
      <motion.div
        ref={sidebarRef}
        variants={Nav_animation}
        initial={{ x: isTabletMid ? -250 : 0 }}
        animate={open ? 'open' : 'closed'}
        //  className="bg-blueBg text-white shadow-xl z-[999] max-w-[16rem] w-[16rem] overflow-hidden md:relative fixed h-screen"
        className="bg-blueBg text-white shadow-xl z-[999] max-w-[16rem] w-[16rem] overflow-hidden fixed h-screen"
      >
        <div className="flex items-center justify-center gap-2.5 font-medium border-b py-3 border-white mx-3">
          {open && (
            // <span className="font-montsettat">
            //   <img
            //     src={`${process.env.REACT_APP_S3_URL}/logo.png`}
            //     alt="logo"
            //     // className="md:h-[130px] md:w-[130px] h-[70px] w-[80px] border-gray-200 p-2 rounded-tr-3xl rounded-bl-3xl"
            //     className="h-[70px] w-[80px] border-gray-200 p-2 rounded-tr-3xl rounded-bl-3xl"
            //   />
            // </span>
            <div className="flex items-center">
              {/* Logo */}
              <img
                src={`${process.env.REACT_APP_S3_URL}/logo.png`}
                alt="logo"
                className="h-[50px] w-[60px] md:h-[80px] md:w-[100px] py-2 object-contain"
              />

              <div className="flex items-center space-x-1 leading-tight">
                <span className="text-white font-bold text-sm md:text-xl font-montserrat md:tracking-[0.3em]">
                  SEVA
                </span>
                <span className="text-white mt-1 italic font-light text-sm md:text-base font-[cursive] font-montserrat">
                  Grievance Portal
                </span>
              </div>
            </div>
          )}
        </div>
        <div className="flex flex-col h-full">
          <ul className="whitespace-pre px-2.5 text-[0.9rem] py-5 flex flex-col gap-1  font-medium overflow-x-hidden   md:h-[68%] h-[70%]">
            {role === 'Grievance-Data-Entry-Operator' && (
              <>
                <li>
                  <NavLink to={'/gms'} className="linkNav">
                    <FaTasks size={23} className="min-w-max" />
                    My Requests
                  </NavLink>
                </li>
                <li>
                  <NavLink to={'/AddGms'} className="linkNav">
                    <MdOutlinePostAdd size={23} className="min-w-max" />
                    Add Request
                  </NavLink>
                </li>
              </>
            )}
            {role === 'Web-Portal-Data-Entry' && (
              <>
                <li>
                  <NavLink to={'/news'} className="linkNav">
                    <LuNewspaper size={23} className="min-w-max" />
                    News
                  </NavLink>
                </li>
                <li>
                  <NavLink to={'/videos'} className="linkNav">
                    <RxVideo size={23} className="min-w-max" />
                    Videos
                  </NavLink>
                </li>
                <li>
                  <NavLink to={'/images'} className="linkNav">
                    <BsImages size={23} className="min-w-max" />
                    Images
                  </NavLink>
                </li>
              </>
            )}
            {(role === 'Super-Admin' ||
              role === 'Admin' ||
              role === 'Grievance-Admin-Access') && (
              <li>
                <NavLink to={'/dashboard'} className="linkNav">
                  <AiOutlineAppstore size={23} className="min-w-max" />
                  Dashboard
                </NavLink>
              </li>
            )}
            {(role === 'Super-Admin' ||
              role === 'Admin' ||
              role === 'Grievance-Admin-Access' ||
              role === 'Grievance-Manager-Access') && (
              <li>
                <NavLink to={'/gms'} className="linkNav">
                  <FaTasks size={23} className="min-w-max" />
                  Grievance Management
                </NavLink>
              </li>
            )}
            {(role === 'Super-Admin' ||
              role === 'Admin' ||
              role === 'Grievance-Admin-Access' ||
              role === 'Grievance-Manager-Access') && (
              <li>
                <NavLink to={'/job-requests'} className="linkNav">
                  <MdOutlinePostAdd size={23} className="min-w-max" />
                  Job Requests
                </NavLink>
              </li>
            )}
            <li>
              {(role === 'Super-Admin' ||
                role === 'Admin' ||
                role === 'Grievance-Admin-Access' ||
                role === 'Grievance-Manager-Access') && (
                <NavLink to={'/budget'} className="linkNav">
                  <CiDollar size={23} className="min-w-max" />
                  MP LADS
                </NavLink>
              )}
            </li>
            {/* <li>
              {(role === 'Super-Admin' ||
                role === 'Admin' ||
                role === 'Grievance-Admin-Access' ||
                role === 'Grievance-Manager-Access') && (
                <NavLink to={'/calendar'} className="linkNav">
                  <FaRegCalendarDays size={23} className="min-w-max" />
                  AMO Calendar
                </NavLink>
              )}
            </li> */}
            <li>
              {(role === 'Super-Admin' ||
                role === 'Admin' ||
                role === 'Grievance-Admin-Access' ||
                role === 'Grievance-Manager-Access') && (
                <NavLink to={'/ttd-calendar/approved-list'} className="linkNav">
                  <FaRegCalendarDays size={23} className="min-w-max" />
                  TTD Calendar
                </NavLink>
              )}
            </li>

            {(role === 'Super-Admin' || role === 'Admin') &&
              settingsMenusList?.map((menu) => (
                <div key={menu.name} className="flex flex-col gap-1">
                  {open && <SubMenu data={menu} />}
                </div>
              ))}
            {(role === 'Super-Admin' || role === 'Admin') &&
              formsMenusList?.map((menu) => (
                <div key={menu.name} className="flex flex-col gap-1">
                  {open && <SubMenu data={menu} />}
                </div>
              ))}
          </ul>
          {open && (
            <div className="flex-1 text-sm z-50  max-h-48 my-auto whitespace-pre w-full font-medium ">
              <div className="flex p-4 items-center justify-between">
                <div className="linkNav">
                  <AiOutlineLogout size={23} />
                  <button onClick={handleLogout}>Logout</button>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* <motion.div
          onClick={() => {
            setOpen(!open);
          }}
          animate={
            open
              ? {
                  x: 0,
                  y: 0,
                  rotate: 0,
                }
              : {
                  x: -10,
                  y: -200,
                  rotate: 180,
                }
          }
          transition={{ duration: 0 }}
          className="absolute w-fit h-fit md:block z-50 hidden right-4 bottom-4 cursor-pointer"
        >
          <IoIosArrowBack size={25} />
        </motion.div> */}
      </motion.div>
      {/* {pathname === "/dashboard" &&(
        <div
        className="p-2 bg-blueBg h-screen md:hidden"
        onClick={() => setOpen(true)}
      >
        <MdMenu size={35} className="text-white" />
      </div>
      )} */}
    </div>
  );
};

export default Sidebar;
